function warningOffset(context) {
  setTimeout(() => {
    context.warningOffset -= 1
    console.log(context.warningOffset)
    if(context.warningOffset>0) warningOffset(context)
    else console.log('Show warning')
  }, 1000)
}

export default warningOffset